import { AsyncPipe, DecimalPipe, NgClass, NgStyle } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgImageSliderModule } from "ng-image-slider";
import { PopupLoginComponent } from "../popup-login/popup-login.component";
import { MessagePopupComponent } from "src/app/shared/commonComponent/MessagePopup/MessagePopup.component";
import { PopupRegisterComponent } from "../popup-register/popup-register.component";
import { GuestloginComponent } from "../login/Guest_login/guestlogin.component";

@Component({
  selector: "app-popup-login-options",
  templateUrl: "./popup-login-options.component.html",
  standalone: true,
  styleUrls: ["./popup-login-options.component.scss"],
  imports: [
    NgStyle,
    NgClass,
    NgSelectModule,
    FormsModule,
    NgImageSliderModule,
    AsyncPipe,
    DecimalPipe,
    MessagePopupComponent,
    PopupLoginComponent,
    PopupRegisterComponent,
    GuestloginComponent,
  ],
})
export class PopupLoginOptionsComponent implements OnInit, OnChanges {
  constructor() {}

  // Merchant$;
  allowGuestCheckout;
  loadLogin = false;
  showLogin = false;
  showRegister;
  showGuest;

  @Input() Merchant$: any;
  @Input() Show: any;
  @Input() FromMultiOutlet: any;
  @Input() FromSingleOutlet: any;
  @Input() FromLocationSelection: any;
  @Input() ShowSkipOption: any;
  @Input() FromFeedback: any;

  @Output() Close = new EventEmitter<string>();

  ngOnInit(): void {}

  ngOnChanges(changes) {
    // if (this.isProductVisible) {
    //   setTimeout(() => {
    //     this.OpenVerticallyCentered(
    //       this.selectedProductTemplate,
    //       this.selectedProductId
    //     );
    //   }, 200);
    // }
  }

  redirectToLogin() {
    this.loadLogin = true;
    this.showLogin = true;
    this.cancelClicked();
  }
  redirectToCreateAccount() {
    this.showRegister = true;
    this.cancelClicked();
  }
  proceedAsGuest() {
    this.showGuest = true;
    this.cancelClicked();
  }
  cancelClicked() {
    this.Close.emit();
  }

  closeLogin() {
    console.log("This is close option1111");
    this.showLogin = false;
    this.Close.emit();
  }

  closeRegistration() {
    this.showRegister = false;
  }

  // Method to set GuestLogin value based on the user input
  guestLogin(value: boolean) {
    this.showGuest = value;
  }

  SkipLogin() {
    localStorage.setItem("skipped_login", "true");
    this.Close.emit();
  }

  get borderStyle(): string {
    const menuColor =
      this.Merchant$?.webapp_settings?.menu_color ?? this.Merchant$?.menu_color;

    const borderColor =
      this.Merchant$?.webapp_settings?.menu_border_color ??
      this.Merchant$?.menu_border_color;

    const borderWidth =
      this.Merchant$?.webapp_settings?.menu_border_width ??
      this.Merchant$?.menu_border_width;

    return menuColor !== borderColor
      ? `${borderWidth}px solid ${borderColor}`
      : `${borderWidth}px solid`;
  }

  get menuBorderColor(): string {
    const menuColor =
      this.Merchant$?.webapp_settings?.menu_font_color_homepgae ??
      this.Merchant$?.menu_font_color_homepgae;

    // const borderColor =
    //   this.Merchant$?.webapp_settings?.menu_border_color ??
    //   this.Merchant$?.menu_border_color;

    return menuColor;
  }
}
